<!--
@Author: Tom Voorneveld <tom>
@Date:   2017-11-24T11:44:01+01:00
@Email:  tom@lorinthe.com
@Project: Lorinthe: "what our customers are saying"
@Last modified by:   tom
@Last modified time: 2019-06-07T13:00:13+02:00
@Copyright: (c) copyright Lorinthe BV, all rights reserved
-->

<template lang="html">
  <section id="testimonial" class="pb-0">
    <!-- class="bg-secondary" -->
    <div class="header text-primary">
      <icon name="bullhorn" scale="2"/>
      <h1>{{ $t('testimonial.title') }}</h1>
    </div>
    <b-container>

      <blockquote
        v-for="f in 3"
        :key = "f"
        class="mb-0 text-center"
        v-html="$t('testimonial.' + f )"/>

    </b-container>
  </section>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>

  #testimonial {
    // color: $primaryWhite;
  }

</style>
